<template>
	<!-- 日程气泡信息 控制同时只渲染一个气泡DOM -->
	<el-popover
		v-if="showPopover"
		placement="right"
		trigger="click"
		popper-class="schedule-popper"
		:visible-arrow="false"
		v-bind="$attrs"
		ref="innerPopover"
	>
		<SchedulePopup :cellDate="scheduleContent.date" :cellData="scheduleContent.data" :data="scheduleContent.item" />
	</el-popover>
</template>

<script setup>
import SchedulePopup from '@/components/calendar/schedule-popup.vue';
import { ref } from 'vue';

defineProps({
	showPopover: {
		type: Boolean,
		default: false
	},
	scheduleContent: {
		type: Object,
		default: () => {}
	}
});

// 转发 ref
const innerPopover = ref(null);
defineExpose({
	current: innerPopover
});
</script>

<style lang="less">
.schedule-popper {
	&.el-popover {
		width: 266px;
		padding: 16px;
		border-radius: 2px;
		background: #fff;
		box-shadow: 1px 4px 16px rgba(0, 0, 0, 0.08);
		border: none;
	}
	&.el-popper[x-placement^='right'] {
		margin-left: 2px;
	}
	&.el-popper[x-placement^='left'] {
		margin-right: 2px;
	}
}
</style>
